import { ActionTree, MutationTree, GetterTree } from 'vuex';

import PaginationUtils from '@/utils/PaginationUtils';

import Module from '../interfaces/module.interface';
import { RootState } from '../types';
import { IOfferListState, IOfferListStateConfig } from '@/models/offerList';

const defaultConfig = () => ({
  filters: {},
  pagination: PaginationUtils.defaultPagination(),
  scrollYPos: 0
});

export const initialState = () => ({
  config: defaultConfig()
});

const actions: ActionTree<IOfferListState, RootState> = {
  RESET_CONFIG({ commit, state }, payload: { config: IOfferListStateConfig }) {
    commit('resetConfig', payload);
  },
  SET_CONFIG({ commit, state }, payload: { config: IOfferListStateConfig }) {
    commit('setConfig', payload);
  }
};

const mutations: MutationTree<IOfferListState> = {
  setConfig(state, payload: { config: IOfferListStateConfig }) {
    Object.assign(state.config, payload.config);
  },
  resetConfig(state) {
    Object.assign(state, {
      offerList: {
        ...state,
        config: defaultConfig()
      }
    });
  }
};

const getters: GetterTree<IOfferListState, RootState> = {
  getOfferListConfigState: state => state.config
};

export const offerList: Module<IOfferListState, RootState> = {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
  getters
};
